module.exports = __webpack_public_path__ + "static/media/data_science.13edb5c1.svg";